import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const NAV_LINKS = [
  { label: 'Home', path: '/' },
  { label: 'About', path: '/about' },
  { label: 'Music', path: '/music' },
  { label: 'Store', path: '/store' },
  { label: 'Gallery', path: '/gallery' },
];

const LOGO_URL =
  'https://static.readdy.ai/image/d1767fc870c8d5c35b9713efade7ccc7/cfa9cf550b39f15ff7c0c1dd12d033ba.png';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-400 ${
        scrolled ? 'bg-black/95 border-b border-brand-yellow/20' : 'bg-transparent'
      }`}
    >
      <nav className="flex items-center justify-between px-6 md:px-12 h-16 md:h-20">
        {/* Logo */}
        <Link to="/" className="flex items-center cursor-pointer">
          <img
            src={LOGO_URL}
            alt="Dirty Birdy Logo"
            className="h-12 md:h-14 w-auto object-contain"
          />
        </Link>

        {/* Desktop Nav */}
        <ul className="hidden md:flex items-center gap-8">
          {NAV_LINKS.map((link) => {
            const isActive = location.pathname === link.path;
            return (
              <li key={link.path}>
                <Link
                  to={link.path}
                  className={`font-heading font-semibold text-sm tracking-widest uppercase transition-colors duration-200 cursor-pointer whitespace-nowrap ${
                    isActive
                      ? 'text-brand-yellow border-b-2 border-brand-yellow pb-0.5'
                      : 'text-white/80 hover:text-brand-yellow'
                  }`}
                >
                  {link.label}
                </Link>
              </li>
            );
          })}
        </ul>

        {/* Mobile Menu Toggle */}
        <button
          className="md:hidden w-8 h-8 flex flex-col items-center justify-center gap-1.5 cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span
            className={`block w-6 h-0.5 bg-white transition-all duration-300 ${
              menuOpen ? 'rotate-45 translate-y-2' : ''
            }`}
          />
          <span
            className={`block w-6 h-0.5 bg-white transition-all duration-300 ${
              menuOpen ? 'opacity-0' : ''
            }`}
          />
          <span
            className={`block w-6 h-0.5 bg-white transition-all duration-300 ${
              menuOpen ? '-rotate-45 -translate-y-2' : ''
            }`}
          />
        </button>
      </nav>

      {/* Mobile Dropdown */}
      <div
        className={`md:hidden overflow-hidden transition-all duration-300 bg-black/97 border-t border-brand-yellow/20 ${
          menuOpen ? 'max-h-80' : 'max-h-0'
        }`}
      >
        <ul className="flex flex-col py-4 px-6 gap-4">
          {NAV_LINKS.map((link) => {
            const isActive = location.pathname === link.path;
            return (
              <li key={link.path}>
                <Link
                  to={link.path}
                  className={`font-heading font-semibold text-base tracking-widest uppercase cursor-pointer whitespace-nowrap ${
                    isActive ? 'text-brand-yellow' : 'text-white/80'
                  }`}
                >
                  {link.label}
                </Link>
              </li>
            );
          })}
        </ul>
      </div>
    </header>
  );
}
